import { useState } from "react";
import "./PageChanger.css";

function PageChanger(props: {
  numPerPage: number;
  setNumPerPage?: (numPerPage: number) => void;
  pageNum: number;
  setPageNum: (pageNum: number) => void;
  numEntries: number;
}) {
  const { numPerPage, setNumPerPage, pageNum, setPageNum, numEntries } = props;
  const [numPerPageInput, setNumPerPageInput] = useState(numPerPage.toString());
  const [pageNumInput, setPageNumInput] = useState((pageNum + 1).toString());
  const maxPageNum = Math.ceil(numEntries / numPerPage) - 1;

  const setPageNumAndInput = (num: number) => {
    const clampedNum = Math.min(Math.max(0, num), maxPageNum);
    setPageNum(clampedNum);
    setPageNumInput((clampedNum + 1).toString());
  };
  const setNumPerPageFromInput =
    setNumPerPage === undefined
      ? null
      : (numPerPageInput: string) => {
          const parsed = parseInt(numPerPageInput);
          if (Number.isInteger(parsed) && parsed >= 0) {
            setNumPerPage(parsed);
            const newMaxPageNum = Math.ceil(numEntries / parsed) - 1;
            if (pageNum > newMaxPageNum) setPageNumAndInput(newMaxPageNum);
          }
        };
  const setPageNumFromInput = (pageNumInput: string) => {
    const parsed = parseInt(pageNumInput) - 1;
    if (Number.isInteger(parsed) && parsed >= 0 && parsed <= maxPageNum) {
      setPageNum(parsed);
    }
  };

  if (maxPageNum === 0 && setNumPerPage === undefined) return null;

  return (
    <>
      {setNumPerPageFromInput !== null ? (
        <label className="page-changer-num-per-page">
          <input
            className="page-changer-input"
            type="number"
            inputMode="numeric"
            value={numPerPageInput}
            min={1}
            onInput={(e) => {
              const target = e.target as HTMLInputElement;
              setNumPerPageInput(target.value);
              setNumPerPageFromInput(target.value);
            }}
          />{" "}
          / page
        </label>
      ) : null}
      <div className="page-changer-buttons">
        <a
          className={`page-changer-button ${pageNum === 0 ? "disabled" : ""}`}
          onClick={() => setPageNumAndInput(0)}
        >
          «
        </a>
        <a
          className={`page-changer-button ${pageNum === 0 ? "disabled" : ""}`}
          onClick={() => setPageNumAndInput(pageNum - 1)}
        >
          ‹
        </a>
        <input
          className="page-changer-input"
          type="number"
          inputMode="numeric"
          value={pageNumInput}
          min={1}
          max={maxPageNum + 1}
          onInput={(e) => {
            const target = e.target as HTMLInputElement;
            setPageNumInput(target.value);
            setPageNumFromInput(target.value);
          }}
        />
        <a
          className={`page-changer-button ${
            pageNum === maxPageNum ? "disabled" : ""
          }`}
          onClick={() => setPageNumAndInput(pageNum + 1)}
        >
          ›
        </a>
        <a
          className={`page-changer-button ${
            pageNum === maxPageNum ? "disabled" : ""
          }`}
          onClick={() => setPageNumAndInput(maxPageNum)}
        >
          »
        </a>
      </div>
    </>
  );
}

export default PageChanger;
